import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from '../components/header/Header';
import { AuthProvider } from '../context/AuthContext';
import { BrandProvider } from '../context/BrandContext';
import { LocationProvider } from '../context/LocationContext';
import { OrderProvider } from '../context/OrderContext';
import { ToastProvider } from '../context/ToastModalContext';
import { ModalProvider } from '../context/ModalContext';
import AccountDeletion from '../features/accountDeletion/AccountDeletion';
import AddCredit from '../features/addCredit/AddCredit';
import AddCreditCard from '../features/addCreditCard/AddCreditCard';
import { ChargerStatus } from '../features/charger-status/ChargerStatus';
import Charger from '../features/charger/Charger';
import CreditExtract from '../features/extract/creditExtract/CreditExtract';
import Extract from '../features/extract/Extract';
import RechargeExtract from '../features/extract/rechargeExtract/RechargeExtract';
import TransferExtract from '../features/extract/transferExtract/TransferExtract';
import ForgotPassword from '../features/forgotPassword/ForgotPassword';
import Home from '../features/home/Home';
import Login from '../features/login/Login';
import NotFound from '../features/notfound/NotFound';
import PaymentMethods from '../features/payment/PaymentMethods';
import Pix from '../features/pix/Pix';
import QrReaderPage from '../features/qrReader/QrReader';
import { RechargePriority } from '../features/recharge-priority/RechargePriority';
import { ViewerContainerPage } from '../features/viewers/page';
import RechargeInfo from '../features/recharge/RechargeInfo';
import SucessRedefinePassword from '../features/redefinePassword/sucessRedefinePassword/SucessRedefinePassword';
import Register from '../features/register/Register';
import SwitchPassword from '../features/switchPassword/SwitchPassword';
import UserProfile from '../features/userProfile/UserProfile';
import SucessAccountConfirmation from '../features/sucessAccountConfirmation/SucessAccountConfirmation';
import { Valet } from '../features/valet/Valet';
import { Redirector } from '../features/redirector';
import { VehicleDetail, VehicleList } from '../features/Vehicles';
import { ChargerStatus as ChargerStatusValet } from '../features/viewers/valet/charger-status/ChargerStatus';
import { WebSocketProvider } from '../websocket/websocketProvider';
import ProtectedRoute from './ProtectedRoute';
import Favicon from '../components/favicon/Favicon';
import RedefinePassword from '../features/redefinePassword/RedefinePassword';
import WelcomePassword from '../features/welcomePassword/WelcomePassword';
import SucessWelcomePassword from '../features/welcomePassword/sucessWelcomePassword/SucessWelcomePassword';
import Terms from '../features/terms/terms';
import PrivacyPolicy from '../features/privacyPolicy/PrivacyPolicy';
import Coupons from '../features/coupons/Coupons';
import { useToastStore } from '../hooks/useToastStore';
import { HeaderProvider } from '../context/HeaderContext';
import { isWebView } from '../utils/detectWebContainer';
import OneSignalProvider from '../providers/OneSignalProvider';

const appStyle: React.CSSProperties = {
  height: '100vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
};

const routerStyle: React.CSSProperties = {
  flex: 1,
  overflowY: 'auto', // conteúdo vira scroll
  display: 'flex',
  flexDirection: 'column',
};

function MissingRoute() {
  const location = useLocation();
  const brandPath: string | null = location?.pathname?.split('/')[1];

  useEffect(() => {
    window.location.replace(`/${brandPath ? brandPath : 'spott'}/`);
  });
  return <></>;
}

export const renderViewer = () => {
  const webView = isWebView();
  return (
    <div style={appStyle}>
      <div
        style={{
          ...routerStyle,
          ...(webView && { paddingBottom: 40 }),
        }}
      >
        {/* <Favicon /> */}
        <LocationProvider>
          <ModalProvider>
            <Routes>
              <Route
                path='/viewers/fleet/charger-status/:id'
                element={<ChargerStatus />}
              />
              <Route
                path='/viewers/fleet/recharge-priority/:id'
                element={<RechargePriority />}
              />
              {/* charger-status | recharge-priority | fleet-map */}
              <Route
                path='/viewers/fleet-sites/:page/:id'
                element={<ViewerContainerPage />}
              />
              <Route
                path='/viewers/vallet/charger-status/:id'
                element={<ChargerStatusValet />}
              />
              <Route path='/redir' element={<Redirector />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
          </ModalProvider>
        </LocationProvider>
      </div>
    </div>
  );
};

export const RenderApp = (location: any, params: any) => {
  const { showConnectingToast } = useToastStore();
  const webView = isWebView();
  const currentPath = location.pathname.split('/')[2] || '';
  // console.log('currentPath', currentPath);

  const blacklistToPaddingBottom = [
    'qrcode',
    'recharge',
    'charger',
    'coupons',
    'extract',
  ];
  return (
    <BrandProvider location={location} params={params}>
      <LocationProvider>
        <AuthProvider>
          <WebSocketProvider>
            <ModalProvider>
              <ToastProvider>
                <OrderProvider>
                  <OneSignalProvider>
                    <HeaderProvider>
                      <div
                        style={{
                          ...appStyle,
                          ...(showConnectingToast
                            ? {
                                position: 'fixed',
                                width: '100vw',
                                height: '100vh',
                                top: 0,
                                left: 0,
                              }
                            : {}),
                        }}
                      >
                        <div style={{ flexShrink: 0 }}>
                          <Header />
                        </div>
                        <div
                          style={{
                            ...routerStyle,
                            ...(webView &&
                              !blacklistToPaddingBottom.includes(
                                currentPath
                              ) && {
                                paddingBottom: 40,
                              }),
                          }}
                        >
                          <Favicon />
                          <Routes>
                            <Route path='/:segment/' element={<Home />} />
                            <Route path='/:segment/login' element={<Login />} />
                            <Route
                              path='/:segment/forgot-password-app/:token'
                              element={<RedefinePassword />}
                            />
                            <Route
                              path='/:segment/welcome-password/:token'
                              element={<WelcomePassword />}
                            />
                            <Route
                              path='/:segment/forgotPassword'
                              element={<ForgotPassword />}
                            />
                            <Route
                              path='/:segment/switchPassword/:hasPassword?'
                              element={<SwitchPassword />}
                            />
                            <Route
                              path='/:segment/sucessRedefinePassword'
                              element={<SucessRedefinePassword />}
                            />
                            <Route
                              path='/:segment/sucessWelcomePassword'
                              element={<SucessWelcomePassword />}
                            />
                            <Route
                              path='/:segment/confirmation-app'
                              element={<SucessAccountConfirmation />}
                            />
                            <Route
                              path='/:segment/register'
                              element={<Register />}
                            />
                            {/* Exige login: a API de conectores do local (SiteConnectors) deixou de
                                aceitar acesso anônimo em 28/09/2026, igual ao app. */}
                            <Route
                              path='/:segment/charger/:id'
                              element={
                                <ProtectedRoute>
                                  <Charger />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path='/:segment/recharge/:chargePointId/:connectorId'
                              element={<RechargeInfo />}
                            />
                            <Route
                              path='/:segment/qrcode/'
                              element={<QrReaderPage />}
                            />
                            <Route
                              path='/:segment/terms-of-use'
                              element={<Terms />}
                            />
                            <Route
                              path='/:segment/privacy-policy'
                              element={<PrivacyPolicy />}
                            />
                            <Route
                              path='/:segment/paymentMethods'
                              element={<PaymentMethods />}
                            />
                            <Route
                              path='/:segment/addCreditCard/:currenCreditCardId?'
                              element={<AddCreditCard />}
                            />
                            <Route
                              path='/:segment/addCredit/:currenCreditCardId?'
                              element={<AddCredit />}
                            />
                            <Route
                              path='/:segment/addPix/:orderId?'
                              element={<Pix />}
                            />
                            <Route
                              path='/:segment/extract'
                              element={<Extract />}
                            />
                            <Route
                              path='/:segment/extract/recharge/:id'
                              element={<RechargeExtract />}
                            />
                            <Route
                              path='/:segment/extract/credit/:id'
                              element={<CreditExtract />}
                            />
                            <Route
                              path='/:segment/extract/transfer/:id'
                              element={<TransferExtract />}
                            />
                            <Route
                              path='/:segment/userProfile'
                              element={<UserProfile />}
                            />
                            {/* <Route
                          path='/:segment/savedRechargeCards'
                          element={<SavedRechargeCards />}
                        />
                        <Route
                          path='/:segment/newRechargeCard/:tagId?'
                          element={<NewRechargeCard />}
                        /> */}
                            <Route
                              path='/:segment/ch/:cpcode'
                              element={<QrReaderPage />}
                            />
                            <Route
                              path='/:segment/accountDeletion'
                              element={
                                <ProtectedRoute>
                                  <AccountDeletion />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path='/:segment/vehicles-list'
                              element={
                                <ProtectedRoute>
                                  <VehicleList />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path='/:segment/vehicles'
                              element={
                                <ProtectedRoute>
                                  <VehicleDetail />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path='/:segment/vehicle-detail/:uvId'
                              element={
                                <ProtectedRoute>
                                  <VehicleDetail />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path='/:segment/coupons'
                              element={
                                <ProtectedRoute>
                                  <Coupons />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path='/:segment/valet/:id'
                              element={
                                <ProtectedRoute>
                                  <Valet />
                                </ProtectedRoute>
                              }
                            />
                            <Route path='*' element={<MissingRoute />} />
                          </Routes>
                        </div>
                      </div>
                    </HeaderProvider>
                  </OneSignalProvider>
                </OrderProvider>
              </ToastProvider>
            </ModalProvider>
          </WebSocketProvider>
        </AuthProvider>
      </LocationProvider>
    </BrandProvider>
  );
};
